import {getPostsData} from "../../../library/components/posts-feed/api";

export async function api_getSeriesPosts(community_uid,series_id,ids) {

    const {posts_data} = await getPostsData(ids,community_uid);

    return posts_data;
}